import { http } from "../../services/api.services";

export const ShopService = {
  getShops: () => http.get("/shops?filter[is_popular]=1&without_pagination=1")
}